export const pageDataLoadWindowMs = 2000;
export const progressBarHideDelayMs = 300;
